import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  font-size: 18px;
  font-family: 'BlocketSans-Medium', sans-serif;
  text-align: center;
  padding: 0 6px;
`

export default function TextOverlay({ children }) {
  return <Wrapper>{children}</Wrapper>
}

TextOverlay.propTypes = {
  children: PropTypes.node,
}
